import { render, staticRenderFns } from "./SelectSearchEventsDropdown.vue?vue&type=template&id=b18bdaaa"
import script from "./SelectSearchEventsDropdown.vue?vue&type=script&lang=js"
export * from "./SelectSearchEventsDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectSearchEventsDropdown.vue?vue&type=style&index=0&id=b18bdaaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports